module.exports = __webpack_public_path__ + "img/ticket.ab8b3c16.svg";